<template>
  <div class="c-serviceDetailRating">
    <div class="c-ratingSummary">
      <div class="c-overAll">
        <div class="c-overAll_heading">総合評価</div>
        <div class="c-overAll_star">
          <c-rating-stars
            :size="21"
            :score="ratingIndicators.overall.indicator"
          />
        </div>
        <div class="c-overAll_count">
          {{ displayFixed(ratingIndicators.overall.indicator) }}
        </div>
      </div>

      <div class="c-indicators">
        <div
          class="c-indicators_item c-indicator"
          v-if="ratingIndicators.description && ratingIndicators.description.indicator >= 0"
        >
          <div class="c-indicator_heading">
            サービス内容/提案のわかりやすさ
            <rating-tooltip
              v-if="isPC"
              :title="ragingTooltips.description.title"
              class="c-tooltip"
            >
              <div
                class="c-tooltip_help"
                slot="body"
              >{{ ragingTooltips.description.body }}</div>
            </rating-tooltip>
          </div>
          <div class="c-indicator_star">
            <c-rating-stars
              :size="16"
              :score="ratingIndicators.description.indicator"
            />
          </div>
        </div>

        <div
          class="c-indicators_item c-indicator"
          v-if="ratingIndicators.communication && ratingIndicators.communication.indicator >= 0"
        >
          <div class="c-indicator_heading">
            コミュニケーション
            <rating-tooltip
              v-if="isPC"
              :title="ragingTooltips.communication.title"
              class="c-tooltip"
            >
              <div
                class="c-tooltip_help"
                slot="body"
              >{{ ragingTooltips.communication.body }}</div>
            </rating-tooltip>
          </div>
          <div class="c-indicator_star">
            <c-rating-stars
              :size="16"
              :score="ratingIndicators.communication.indicator"
            />
          </div>
        </div>

        <div
          class="c-indicators_item c-indicator"
          v-if="ratingIndicators.quality && ratingIndicators.quality.indicator >= 0"
        >
          <div class="c-indicator_heading">
            クオリティ
            <rating-tooltip
              v-if="isPC"
              :title="ragingTooltips.quality.title"
              class="c-tooltip"
            >
              <div
                class="c-tooltip_help"
                slot="body"
              >{{ ragingTooltips.quality.body }}</div>
            </rating-tooltip>
          </div>
          <div class="c-indicator_star">
            <c-rating-stars
              :size="16"
              :score="ratingIndicators.quality.indicator"
            />
          </div>
        </div>

        <div
          class="c-indicators_item c-indicator"
          v-if="ratingIndicators.schedule && ratingIndicators.schedule.indicator >= 0"
        >
          <div class="c-indicator_heading">
            納期/スケジュール
            <rating-tooltip
              v-if="isPC"
              :title="ragingTooltips.schedule.title"
              class="c-tooltip"
            >
              <div
                class="c-tooltip_help"
                slot="body"
              >{{ ragingTooltips.schedule.body }}</div>
            </rating-tooltip>
          </div>
          <div class="c-indicator_star">
            <c-rating-stars
              :size="16"
              :score="ratingIndicators.schedule.indicator"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="c-ratingComments">
      <ul class="c-ratingCommentsList">
        <li
          v-for="(rating, index) in serviceDetailRatings.ratingCommentsList"
          :key="`rating${index}`"
          class="c-ratingCommentsList_item"
          v-show="isShowDefaultAll || index < defaultDisplayNum"
        >
          <div class="c-buyer">
            <div class="c-buyer_icon">
              <c-user-icon-v2
                :file-path="rating.buyer.id ? rating.buyer.icon : ''"
                :user-name="rating.buyer.name"
                :size="isSP || isTB ? 32 : 40"
                :isFromSystem="rating.isFromSystem"
                v-if="rating.buyer.id || rating.isFromSystem"
              />
              <img
                class="c-userIcon c-userIcon-anonymous"
                src="@/assets/images/common/anonymous-person-f.png"
                alt="女性"
                loading="lazy"
                decoding="async"
                v-else-if="rating.buyer.sex === sexFemale"
              />
              <img
                class="c-userIcon c-userIcon-anonymous"
                src="@/assets/images/common/anonymous-person-m.png"
                :alt="rating.buyer.sex === sexMale ? '男性' : '匿名'"
                loading="lazy"
                decoding="async"
                v-else
              />
            </div>
            <div class="c-buyer_comment">
              <div class="c-buyerCommentRow c-buyerCommentRow-column">
                <div class="c-buyerCommentRow_stars">
                  <c-rating-stars
                    :size="14"
                    :score="rating.rate"
                  />
                </div>
                <div class="c-buyerCommentRow_date">
                  {{ $util.dayjs.unix(rating.created).format('YYYY-MM-DD H:mm:ss') }}
                </div>
              </div>
              <div class="c-buyerCommentRow">
                <span v-if="rating.buyer.id && !rating.isFromSystem">
                  by <span class="c-buyerCommentRow_name">{{ rating.buyer.name }}</span>
                </span>
                <span
                  class="c-buyerCommentRow_name"
                  v-else-if="!rating.isFromSystem"
                >by {{ displayAnonymousPerson(rating.buyer.name, rating.buyer.sex) }}</span>
                <span
                  class="c-buyerCommentRow_name"
                  v-else
                >{{ rating.buyer.name }}</span>
              </div>
            </div>
          </div>
          <div class="c-buyerCommentBody">
            <div class="c-buyerCommentBody_comment">
              <div
                v-text="rating.comment"
                v-if="!rating.deleteFlag"
              ></div>
              <div v-else>不適切な内容が含まれていたため、運営にてコメントを削除いたしました。不適切な内容についての詳細は<a
                  :href="$coconala.helpURL('/articles/360010558453')"
                  target="_blank"
                >こちら</a>
              </div>
            </div>
          </div>
          <div class="c-buyerCommentLabel">
            <div class="c-labels">
              <div
                class="c-labels_cancel"
                v-if="rating.isCancelRating"
              >
                途中終了した取引
              </div>
              <div
                class="c-labels_customize"
                v-if="rating.isCustomize"
              >
                見積り相談
              </div>
            </div>
          </div>
          <rating-comment-reply
            :ratingReply="rating.reply"
            v-if="rating.reply.id"
          />
          <div
            class="c-talkroomLink"
            v-if="isMyService"
          >
            <a :href="`/talkrooms/${rating.talkroomId}`">
              <coconala-icon
                name="chevron-right"
                size="11px"
              />
              この評価のトークルームを見る
            </a>
          </div>
        </li>
      </ul>
      <div
        class="c-loading"
        v-if="isLoadingRatings"
      >
        <b-loading
          :active="isLoadingRatings"
          :is-full-page="false"
        />
      </div>
      <!-- 初回は取得分全部表示せずコンポーネントで表示を制限する -->
      <div
        class="c-readMore"
        v-if="!isShowDefaultAll && serviceDetailRatings.ratingCommentsList.length > defaultDisplayNum"
      >
        <a @click="isShowDefaultAll = true">
          もっと見る
          <coconala-icon
            name="chevron-down"
            size="11px"
          />
        </a>
      </div>
      <!-- 追加分の取得 -->
      <div
        class="c-readMore"
        v-if="isShowDefaultAll && serviceDetailRatings.ratingCommentsList.length < ratingCount"
      >
        <a @click="getMoreRatings(serviceDetailRatings.page)">
          もっと見る
          <coconala-icon
            name="chevron-down"
            size="11px"
          />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
const SEX_FEMALE = 'F'
const SEX_MALE = 'M'
const DEFAULT_DISPLAY_NUM = 10
const DEFAULT_DISPLAY_NUM_LOGGED_IN = 2
const RATING_TOOLTIPS = {
  description: {
    title: 'サービス内容/提案のわかりやすさについて',
    body: 'サービスの説明内容と実際に提供されたものがあっていたかを表す指標です。'
  },
  communication: {
    title: 'コミュニケーションについて',
    body: '出品者の方とのコミュニケーションがスムーズだったか、マナーがよかったかを表す指標です。'
  },
  quality: {
    title: 'クオリティについて',
    body:
      'サービス価格やサービス内容に記載してあることと、実際に提供されたもののクオリティがあっていたかを表す指標です。'
  },
  schedule: {
    title: 'スケジュールについて',
    body: '決められた納期が守られていたか、もしくはスムーズに納品されたかを表す指標です。'
  }
}

import CRatingStars from '~/components/atoms/CRatingStars'

// local components
import RatingTooltip from './RatingTooltip'
import RatingCommentReply from './RatingCommentReply'

// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'ContentsRating',
  components: {
    CRatingStars,
    RatingTooltip,
    RatingCommentReply
  },
  props: {
    serviceDetailRatings: {
      type: Object,
      required: true
    },
    ratingIndicators: {
      type: Object,
      required: true
    },
    ratingCount: {
      type: Number,
      default: 0
    },
    isMyService: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ragingTooltips: RATING_TOOLTIPS,
      defaultDisplayNum: DEFAULT_DISPLAY_NUM,
      isShowDefaultAll: true,
      isLoadingRatings: false,
      sexFemale: SEX_FEMALE,
      sexMale: SEX_MALE
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapGetters('auth', ['isLoggedIn'])
  },
  mounted() {
    if (this.isLoggedIn) {
      this.defaultDisplayNum = DEFAULT_DISPLAY_NUM_LOGGED_IN
      this.isShowDefaultAll = false
    }
  },
  methods: {
    displayFixed(value, digit = 1) {
      return value.toFixed(digit)
    },
    displayAnonymousPerson(name, sex) {
      if (sex === this.sexFemale) {
        return '女性'
      } else if (sex === this.sexMale) {
        return '男性'
      }
      return name
    },
    async getMoreRatings(page) {
      const getPage = page + 1
      const params = this.$route.params
      const query = this.$route.query
      this.isLoadingRatings = true
      try {
        await this.$store.dispatch('pages/services/serviceDetailRatings/getMoreRatings', {
          params,
          query,
          page: getPage
        })
      } catch ({ grpcCode, message }) {
        this.$notify({
          group: 'flash',
          title: 'エラーが発生しました',
          text: 'しばらく時間をおいてからやり直してください',
          type: 'error',
          max: 1
        })
      }
      this.isLoadingRatings = false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-ratingSummary {
  padding-bottom: 16px;
  border-bottom: 1px solid $color-gray-200;
}

.c-overAll {
  display: flex;
  font-size: 16px;

  align-items: center;

  &_heading {
    margin-right: 20px;

    align-self: center;
  }

  &_star {
    margin-right: 12px;

    align-self: center;
  }

  &_count {
    padding-bottom: 4px;
    font-size: 20px;
    line-height: 1;

    align-self: center;
  }
}

.c-indicators {
  display: flex;
  margin-top: 12px;

  flex-wrap: wrap;

  &_item {
    padding: 2px 0;

    flex-basis: 325px;

    &:nth-child(odd) {
      margin-right: 40px;
    }
  }
}

.c-indicator {
  display: flex;

  justify-content: space-between;

  &_heading {
    font-size: 13px;
    line-height: 22px;
  }

  &_star {
    text-align: right;
  }
}

.c-tooltip {
  display: inline;

  &_help {
    font-weight: normal;
    font-size: 12px;
  }
}

.c-ratingComments {
  margin-top: 24px;
}

.c-buyer {
  display: flex;

  &_icon {
    flex: 0 0 40px;
    overflow: hidden;
    margin-right: 20px;
    width: 40px;
    height: 40px;
  }

  &_comment {
    flex: 1 1 auto;
  }
}

.c-buyerCommentRow {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &-column {
    justify-content: space-between;
  }

  &_date {
    color: $color-gray-600;
    text-align: right;
    font-size: 10px;
  }
}

.c-buyerCommentBody {
  margin: 0 0 8px 60px;

  &_comment {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}

.c-buyerCommentLabel {
  margin-left: 60px;
}

.c-userIcon {
  &-anonymous {
    max-width: 172px;
    max-height: 172px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.c-commentReply {
  display: flex;

  &_icon {
    flex: 0 0 24px;
    overflow: hidden;
    margin-right: 12px;
    margin-left: 60px;
    width: 24px;
    height: 24px;
  }

  &_comment {
    flex: 1 1 auto;
  }
}

.c-labels {
  display: flex;

  &_cancel {
    margin-right: 8px;
    padding: 4px 8px;
    border: 1px solid $color-gray-100;
    background: $color-gray-100;
    color: $color-gray-700;
    font-size: 11px;
    line-height: 1;
  }

  &_customize {
    padding: 4px 8px;
    border: 1px solid $color-gray-500;
    color: $color-gray-500;
    font-size: 11px;
    line-height: 1;
  }
}

.c-readMore {
  position: relative;
  margin-top: 16px;
  margin-bottom: 8px;
  color: $color-blue-500;
  font-size: 13px;
}

.c-talkroomLink {
  @include link-effect;

  margin-top: 16px;
  margin-left: 60px;
  color: $color-blue-500;
  font-size: 13px;
}

.c-loading {
  position: relative;
  display: flex;
  padding: 12px;
  width: 100%;
  height: 80px;
  font-size: 14px;

  align-items: center;
  justify-content: center;
}

@media (max-width: breakpoint(ServiceDetail, M)) {
  .c-serviceDetailRating {
    padding: 12px 0;
  }

  .c-ratingSummary {
    padding: 0 12px;
    border-bottom: 0;
  }

  .c-overAll {
    justify-content: space-between;

    &_star {
      flex: 1 1 auto;
      text-align: right;
    }
  }

  .c-indicators {
    &_item {
      padding: 2px 0;

      flex-basis: 100%;

      &:nth-child(odd) {
        margin-right: 0;
      }
    }
  }

  .c-ratingComments {
    margin-top: 16px;
  }

  .c-ratingCommentsList {
    &_item {
      padding: 12px 12px 0;
      border-top: 1px solid $color-gray-50;
    }
  }

  .c-buyer {
    margin-bottom: 8px;

    &_icon {
      margin-right: 20px;
      width: 32px;
      height: 32px;

      flex-basis: 32px;
    }
  }

  .c-buyerCommentBody {
    margin-left: 0;
  }

  .c-buyerCommentLabel {
    margin-bottom: 12px;
    margin-left: 0;
  }

  .c-userIcon {
    &-anonymous {
      width: 32px;
      height: 32px;
    }
  }

  .c-commentReply {
    margin-bottom: 12px;

    &_icon {
      margin-left: 52px;
    }
  }

  .c-talkroomLink {
    margin-bottom: 12px;
    margin-left: 0;
  }

  .c-loading {
    padding: 0 12px;
  }

  .c-readMore {
    padding: 0 12px;
  }
}

@media (min-width: breakpoint(ServiceDetail, M) + 1) {
  .c-ratingCommentsList {
    &_item {
      & + & {
        margin-top: 24px;
      }
    }
  }
}
</style>
